export default __webpack_public_path__ + "assets/images/ca97eee709ac963f04e76d60c08a5413.png";